import { render, staticRenderFns } from "./ChatSettings.vue?vue&type=template&id=a94b6db8&scoped=true&"
import script from "./ChatSettings.vue?vue&type=script&lang=js&"
export * from "./ChatSettings.vue?vue&type=script&lang=js&"
import style0 from "./ChatSettings.vue?vue&type=style&index=0&id=a94b6db8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94b6db8",
  null
  
)

export default component.exports